import { Box, ColumnConfig } from 'grommet/components';
import { DataTableHeader } from '../common/DataTableHeader';
import { DataTableItem } from '../common/DataTableItem';
import { ApiData } from '/src/lib/models';

export const API_DATA_FILTER_DEFAULTS = {
  chargingNetwork: undefined,
  subOrganization: undefined,
  serialNumber: undefined,
  state: undefined,
  chargerLevel: undefined,
  startDate: undefined,
  endDate: undefined,
};

export const getDefaultColumns = (availableColumns: string[]): string[] => availableColumns?.slice(0, 8) || [];

const isEmptyValue = (value: ApiData[string] | null | undefined) =>
  value === null || value === undefined || value === '';

export const columnDefinition = (name: string): ColumnConfig<ApiData> => ({
  property: name,
  align: 'center',
  header: <DataTableHeader title={name} toUpperCase />,
  render: (dataRow: ApiData) => (
    <Box pad={{ vertical: '1rem' }} align="center" width={{ min: '10rem' }}>
      <DataTableItem>{isEmptyValue(dataRow[name]) ? '—' : dataRow[name]}</DataTableItem>
    </Box>
  ),
});
